<!-- 采购订单数据操作 -->
<template>
  <div>
    <div>
      <div class="demo-drawer__content data_action_form">
        <!-- 主要信息 -->
        <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
          <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val)=>{showTabs=val}" @tabHeight="(val)=>{mxHeight=val}">
            <template slot="tabs" slot-scope="scope">
              <div class="table_content_box" v-if="scope.index==0">
                <el-form :inline="true" size="mini">
                  <div v-if="dataActionBox.actionType != 2" id="operateBtn">
                    <el-button type="primary" size="mini" @click="deleteDetails()">删除
                    </el-button>
                    <el-button @click="openExtSearch('8820873997127690')" size="mini" type="primary">提取</el-button>
                    <el-link :underline="false" type="danger" style="margin-left: 10px">
                      Alt+F2：删除明细)</el-link>
                  </div>
                  <el-table ref="mxTableRef" id="mxTable" stripe :data="returnData.list" :height="mxHeight" border style="width: 100%" highlight-current-row size="mini">
                    <el-table-column label="选择操作" width="80">
                      <template slot-scope="scope">
                        <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                          <i class="el-icon-thumb"></i>
                        </el-radio>
                      </template>
                    </el-table-column>
                    <!-- 采购订单主表格 -->
                    <el-table-column align="center" v-if="tableValye.isShow==1" v-for="(tableValye,tableKey) in scope.row.jurconfigform" :key="tableKey" show-overflow-tooltip :prop="tableValye.entityField" :min-width="tableValye.fieldWeight" :label="tableValye.showField">
                      <template slot-scope="scope">
                        <el-tag size="mini" v-if="tableValye.entityField == 'isWms'">
                          {{scope.row.isWms == 0 ? '否' : '是'}}
                        </el-tag>
                        <el-tag size="mini" v-else-if="tableValye.entityField == 'psomState'">
                          {{$common.getIsGsp(tableValye.formatterContent,scope.row.psomState)}}</el-tag>
                        <span v-else-if="tableValye.fieldType == 'date'">
                          <span v-if="scope.row[tableValye.entityField]">
                            {{$common.getLocalTime(scope.row[tableValye.entityField])}}
                          </span>
                        </span>
                        <span v-else-if="tableValye.isRift == 1">
                          <a @click="toDetail(scope.row[tableValye.riftField])">{{scope.row[tableValye.entityField]}}</a>
                        </span>
                        <el-input :ref="tableValye.entityField" @blur="blur(scope.$index,tableValye.entityField)" v-else-if="tableValye.entityField=='lowestPrice'" @focus="focus(scope.$index,tableValye.entityField)" @input="input(scope.$index,'lowestPrice',scope.row)" v-model.trim="scope.row['lowestPrice']"> </el-input>
                        <el-input :ref="tableValye.entityField" @blur="blur(scope.$index,tableValye.entityField)" v-else-if="tableValye.entityField=='recoPrice'" @focus="focus(scope.$index,tableValye.entityField)" @input="input(scope.$index,'recoPrice',scope.row)" v-model.trim="scope.row['recoPrice']"> </el-input>
                        <span v-else>
                          {{scope.row[tableValye.entityField]}}
                        </span>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-form>
              </div>
            </template>
          </v-tabs>
        </el-card>
        <div class="foot">
          <div>
            <el-button v-if="dataActionBox.actionType == 2 && $common.checkIsPrint()" type="primary" @click="showPrintPlan">打印
            </el-button>
            <el-button v-if="dataActionBox.actionType != 2" type="primary" @click="initActionBox()">取消</el-button>
            <el-button type="primary" @click="sendDataAction()" v-if="dataActionBox.actionType == 0">保存</el-button>
            <el-button type="primary" @click="sendDataAction()" v-if="dataActionBox.actionType == 1">保存</el-button>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
      <SearchSchemeMultiple ref="searchSchemeMultiple" :id="searchId" :parentData="parentData" :parentSearchData="parentSearchData" @TranData="changeInputModel" @selection="selection" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="DialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="getSelect">确认选择</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import SearchSchemeMultiple from "../byComponents/SearchSchemeMultiple.vue";
export default {
  name: "lotPriceListAction",
  props: ["actionData"],
  //import引入的组件需要注入到对象中才能使用
  components: {
    SearchSchemeMultiple,
  },
  data() {
    //这里存放数据
    return {
      mxHeight: 0,
      showTabs: "",
      seWidth: "",
      exWidth: "",
      exTitle: "",
      seTitle: "",
      tabForm: [],
      dataActionBox: {
        showStatus: false,
        openMode: "ltr" || "rtl",
        boxTitle: "新增" || "编辑",
        actionType: 0, // 0新增，1修改
      },
      footForm: [],
      mxForm: [],
      mxForm2: [],
      returnData: {
        list: [],
      },
      DialogVisible: false,
      sField: "",
      parentSearchData: {
        cmId: "",
        coId: "",
        opmId: "",
        salesId: "",
        depId: "",
      },
      searchId: "",
      selectedDataIndex: 0,
      selectelist: [],
      parentData: {
        type: "bgsId",
        list: []
      },

    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    DialogVisible() {
      if (!this.DialogVisible) {
        this.selectelist = []
      }
    },
  },
  //方法集合
  methods: {
    blur(index,entityField){
      this.returnData.list[index][entityField]=this.$common.getDecimalInfo(2, this.returnData.list[index][entityField])
    },
    async sendDataAction() {
      if (this.returnData.list.length == 0) {
        this.$message.error("请添加数据")
        return
      }
      var flag = false
      this.returnData.list.forEach((item, index) => {
        if (item.lowestPrice <= 0) {
          this.$refs['lowestPrice'][index].$el.children[0].style = "border:1px solid red !important;"
          flag = true
        }
        if (item.recoPrice <= 0) {
          this.$refs['recoPrice'][index].$el.children[0].style = "border:1px solid red !important;"
          flag = true
        }
      })
      if (flag) {
        this.$message.error("建议售价和最低售价不能为0")
        return
      }
      var arr = []
      this.returnData.list.forEach(item => {
        arr.push(
          {
            "bgmId": item.bgmId,
            "bgsId": item.bgsId,
            "lowestPrice": item.lowestPrice,
            "recoPrice": item.recoPrice
          }
        )
      })
      const responseData = await this.$http.bgStockaddLotPrice(arr)
      console.log(responseData);
      if (responseData.status == 200) {
        this.$message.success(responseData.message)
        this.$emit('drawerCancel')
      }
    },
    focus(index, entityField) {
      this.selectedDataIndex = index
      this.$refs[entityField][index].$el.children[0].style = ""
    },
    input(index, entityField, rows) {
      if (rows[entityField] <= 0) {
        this.returnData.list[index][entityField] = 1
      }
    },
    deleteDetails() {
      if (this.returnData.list.length > 0) {
        this.returnData.list.splice(
          this.selectedDataIndex,
          1
        );
        this.selectedDataIndex = 0;
      } else {
        return this.$message({
          message: "暂无可删除明细",
          type: "warning",
        });
      }
    },
    getSeWidth(e) {
      this.seWidth = e + "%";
    },
    getWidth(e) {
      this.exWidth = e + "%";
    },
    getSearchName(e) {
      this.seTitle = e;
    },
    getExtractName(e) {
      this.exTitle = e;
    },
    //触发提取
    openExtSearch(searchId) {
      this.searchId = searchId
      this.parentData.list = this.returnData.list
      this.DialogVisible = true;
    },
    openBox() {
      this.dataActionBox.actionType = this.actionData.cate
      this.formDataList = this.actionData.formData
      this.showTabs = this.actionData.formData[0].jciName
      this.filterMainField()
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.dataActionBox.actionType != 2) {
            this.mxHeight = this.$common.getBtnHeight()
          } else {
            this.mxHeight = this.$common.getHeight()
          }
        }, 16.7)
      });
    },
    checkIsBuyer() { },
    getSelect() {
      this.returnData.list = this.selectelist
      this.DialogVisible = false;
    },
    changeInputModel(val) {
      console.log('回带', this.sField, val);

      if (val != "" || val != undefined) {
        this.DialogVisible = false;
        if (val.depId) {
          this.parentSearchData1.depId = val.depId;
        }
        this.paramValue(val)
        console.log(this.seType);
        if (this.seType == "cmName") {
          this.parentSearchData1.cmId = val.cmId;
          this.parentSearchData.unitId = val.cmId;
        } else if (this.seType == "salesName") {
          this.parentSearchData1.salesId = val.salesId;
        } else if (this.seType == "opmName") {
          if (val.opmId) {
            this.parentSearchData1.opmId = val.opmId;
          }
        } else if (this.seType == "coName") {
          this.parentSearchData1.coId = val.coId;
        }

      }
    },
    // 赋值字段
    paramValue(val) {
      let arr = this.sField.split(',')
    },
    selection(val) {
      this.selectelist = val
    },
    // 过滤表单不同类型
    filterMainField() {
      var mainFormList = []
      this.formDataList.forEach(item => {
        if (item.jciType == 1) {
        } else if (item.jciType == 2) {
          mainFormList.push(item)
          this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform))
        } else if (item.jciType == 3) {
          this.footForm = JSON.parse(JSON.stringify(item.jurconfigform))
        }
      })
      mainFormList.forEach((key, i) => {
        this.tabForm[i] = JSON.parse(JSON.stringify(key))
        this.tabForm[i].isShowForm = 0
        this.tabForm[i].jurconfigform = []
        for (let index = 0; index < key.jurconfigform.length; index++) {
          if (key.jurconfigform[index].isShow == 1) this.tabForm[i].jurconfigform.push(key
            .jurconfigform[index])
        }
      })
    },
    initActionBox(sendDataInfo) {
      this.$confirm("确定取消" + this.dataActionBox.boxTitle + "吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$emit('drawerCancel')
        })
        .catch(() => { });
    },
    getDataByChen(val) {
      console.log(val);
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.$nextTick(() => {
      this.openBox();
      this.checkIsBuyer();
    });
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    addEventListener("keyup", this.keyUp); //创建监听键盘事件
  },
  beforeDestroy() {
    removeEventListener("keyup", this.keyUp);
  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() {
  }, //生命周期 - 更新之后
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.el-row {
  display: flex;
  flex-wrap: wrap;
  padding-right: 20px;
}

.el-drawer {
  outline: none;
}

.v-modal {
  position: static !important;
  width: 100%;
  height: 100%;
  background: transparent;
}

::v-deep .el-alert__content {
  width: 100%;
}
</style>